<template>
  <div class="loading-wrap" :class="{ 'start': !showLoading, 'hide': hideLoading }">
    <div class="cg-wrap">
      <video class="video-bg" preload="auto" autoplay="true" loop="loop" playsinline="" webkit-playsinline="" muted="" volume="0">
        <!-- <source src="https://kg-web-cdn.kingsgroupgames.com/official-website/pc-landing/ss/static/video_1.mp4"  type="video/mp4"> -->
        <source src="https://kg-web-cdn.kingsgroupgames.com/official-website/pc-landing/ss/static/video_11.mp4" type="video/mp4">
        <source src="https://kg-web-cdn.kingsgroupgames.com/official-website/pc-landing/ss/static/video_11.webm" type="video/webm">
      </video>
    </div>
    <div class="logo"></div>
    <div class="progress-wrap">
      <div class="progress-text">
        <div class="left">
          <!-- <span class="text">{{ $t('text_waitting') }}</span> -->
          <span v-if="loadingText" class="text">{{ loadingText }}</span>
          <span v-else class="text">{{ isEntering ? $t('txt_loading') : $t('text_waitting') }}</span>
        </div>
        <div class="progress">{{ ((showProgress > 1 ? 1 : showProgress) * 100).toFixed(1) }}%</div>
      </div>
      <div class="progress-box">
        <div
          class="progress-bar"
          :class="[progressClass]"
          :style="{ width: `${(showProgress > 1 ? 1 : showProgress) * 100}%` }"
        ></div>
      </div>
    </div>
    <!-- <div class="play-btn" :class="{ active: startGame }" @click="play">{{ $t('text_play_btn') }}</div> -->
    <AgreementPopup v-if="!agreement && inCountry" :country="country"></AgreementPopup>
  </div>
</template>

<script>
import AgreementPopup from './popup/AgreementPopup.vue'
export default {
  name: 'GameLoading',
  props: {
    startGame: Boolean,
    hideLoading: Boolean,
    progress: Number,
    loadingText: String
  },
  components: { AgreementPopup },
  watch: {
    startGame (nv) {
      if (nv) {
        ((this.inCountry && this.agreement) || !this.inCountry) && this.play()
      }
    },
    progress (nv, ov) {
      if (nv === 0.8 && ov === 0) {
        this.progressClass = 'slow'
      } else {
        this.progressClass = ''
      }
      if (nv >= ov) {
        this.showProgress = nv
        this.setLog(this.showProgress)
      }
      // if (nv === 0.8) {
      //   this.startAnimate()
      // }
    }
  },
  created () {
    this.$bus.$on('agreement-click', () => {
      window.localStorage.setItem('AGREEMENT_READ', '1')
      this.agreement = true
      if (this.startGame) this.play()
    })
    this.$bus.$on('set-country', (country) => {
      country = window.localStorage.getItem('local-country') || country
      this.country = country
      if (this.countryList.indexOf(country) > -1) {
        this.inCountry = true
      }
    })
  },
  data () {
    return {
      progressClass: '',
      showProgress: 0,
      showLoading: true,
      startTimer: null,
      timer: null,
      isEntering: false,
      logParamTimeSign: 0,
      logParamProgressSign: -1,

      // 用户协议 - 同意后才可进入游戏
      agreement: window.localStorage.getItem('AGREEMENT_READ') === '1',
      countryList: ['NL', 'BE', 'LU', 'DK', 'IE', 'GR', 'SE', 'FI', 'AT', 'CY', 'EE', 'LV', 'LT', 'PL', 'CS', 'SK', 'SI', 'HU', 'MT', 'RO', 'BG', 'HR', 'DE', 'FR', 'IT', 'ES', 'PT', 'CA', 'GB', 'AU', 'NZ', 'US', 'KR', 'TW', 'JP'],
      country: '',
      inCountry: false
    }
  },
  methods: {
    play () {
      if (!this.startGame) return
      this.showLoading = false
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.timer = null
        this.$emit('play')
        this.$bus.$emit('button-gameStart-click')
      }, 600)
    },
    startAnimate () {
      this.startTimer = setInterval(() => {
        if (this.showProgress >= 0.997) {
          this.showProgress = 0.999
          window.progressEndSign = new Date().getTime()
          this.isEntering = true
          clearInterval(this.startTimer)
          this.startTimer = null
          return
        }
        this.showProgress += 0.003
      }, 100)
    },
    setLog (process) {
      // 打点
      // log_param_loading_status: loading - 进度加载状态 | complete 加载完成，进入游戏
      const loadingType = localStorage.getItem('log_param_loading_status') === 'loading' ? 2 : 1
      const progressVal = process * 100
      if (progressVal % 10 === 0 && progressVal > this.logParamProgressSign) {
        this.logParamProgressSign = progressVal
        const duration = parseInt((new Date().getTime() - this.logParamTimeSign) / 1000)
        const logParams = {
          loading_type: loadingType,
          loading_duration: duration,
          loading_progress: process.toFixed(2),
          UI_progress: this.progress.toFixed(2)
        }
        window.loading_bar_status = window.loading_bar_status === 'web_loading_finish' ? 'web_loading_finish' : `web_loading_${progressVal}%`
        this.$utils.log(`web_loading_${progressVal}%`, logParams)
        if (progressVal === 100) this.logParamTimeSign = new Date().getTime()
      }
    }
  },
  beforeDestroy () {
    this.timer && clearTimeout(this.timer)
    this.startTimer && clearTimeout(this.startTimer)
  }
}
</script>

<style lang="scss" scoped>
.loading-wrap{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity .3s;
  // background: #000 url(~@/assets/img/game_loading.jpg) no-repeat top left;
  // background-size: cover;
  &.start{
    opacity: 0;
  }
  &.hide{
    left: 100%;
  }
}
.cg-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000;
  .video-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.play-btn {
  width: 422px;
  height: 101px;
  bottom: 80px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 40px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(~@/assets/img/btn_play.png) no-repeat center center;
  background-size: 100%;
  padding-left: 20px;
  opacity: 0;
  &.active {
    opacity: 1;
    cursor: pointer;
  }
}
.logo{
  width: 300px;
  height: 148px;
  margin-left: -150px;
  position: absolute;
  top: 60px;
  left: 50%;
  background: url(~@/assets/img/logo_ss_l.png) no-repeat center center;
  background-size: contain;
}
.progress-wrap{
  width: 100%;
  padding: 0 280px;
  color: #ffffff;
  position: absolute;
  font-family: PingFangSC-Semibold, PingFang SC;
  left: 0;
  bottom: 90px;
}
.progress-text{
  display: flex;
  align-items: end;
  overflow: hidden;
  justify-content: space-between;
  font-size: 22px;
  font-weight: 600;
  text-shadow: 0px 1px 3px rgba($color: #000000, $alpha: 0.5);
  .left {
    flex: 1;
    overflow: hidden;
  }
  .progress {
    flex-shrink: 0;
    margin-left: 10PX;
  }
}
.text{
  margin-bottom: 12px;
  line-height: 28px;
  text-shadow: 1px -1px 1px rgba($color: #000000, $alpha: 0.5), -1px 1px 1px rgba($color: #000000, $alpha: 0.5), 1px 1px 1px rgba($color: #000000, $alpha: 0.5), -1px -1px 1px rgba($color: #000000, $alpha: 0.5);
}
// loading文字点点点
.dot1{ animation: dotAnim1 1.4s linear infinite; }
.dot2{ animation: dotAnim2 1.4s linear infinite; }
.dot3{ animation: dotAnim3 1.4s linear infinite; }
.progress-box{
  width: 100%;
  height: 20px;
  padding: 0 4px;
  border-radius: 10px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .progress-bar {
    height: 12px;
    border-radius: 6px;
    background: linear-gradient(270deg, #FFF797 0%, #B2864F 100%);
    transition: width .1s linear;
    &.slow {
      transition: width 1.5s linear;
    }
  }
  // .progress-bar{
  //   width: 0;
  //   height: 100%;
  //   border-radius: 8px;
  //   background-color: #FF8039;
  //   overflow: hidden;
  //   position: relative;
  //   &.active{
  //     animation: progressBar 3s linear forwards;
  //   }
  //   &::before{
  //     content: '';
  //     width: 100%;
  //     height: 100%;
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     background: url(~@/assets/img/progress-texture.png) repeat center center;
  //     animation: progressTextture 20s linear infinite;
  //   }
  // }
}

@keyframes dotAnim1 {
  0%{ opacity: 0; }
  20%{ opacity: 0; }
  21%{ opacity: 1; }
  100%{ opacity: 1; }
}
@keyframes dotAnim2 {
  0%{ opacity: 0; }
  40%{ opacity: 0; }
  41%{ opacity: 1; }
  100%{ opacity: 1; }
}
@keyframes dotAnim3 {
  0%{ opacity: 0; }
  60%{ opacity: 0; }
  61%{ opacity: 1; }
  100%{ opacity: 1; }
}
@keyframes progressBar {
  0%{
    width: 0;
  }
  100%{
    width: 100%;
  }
}
@keyframes progressTextture {
  0%{
    background-position: 0 0;
  }
  100%{
    background-position: 0 100%;
  }
}

// 手机
@media screen and (max-width: 768px) {
  .loading-wrap{
    background-image: url(~@/assets/img/game_loading_m.jpg);
  }
  .progress-wrap{
    padding: 0 50px;
    bottom: 60px;
  }
  .progress-text{
    span{
      font-size: 28px;
    }
  }
  .text{
    margin-bottom: 10px;
    line-height: 40px;
  }
  .progress-box{
    height: 26px;
    padding: 1px;
    border-radius: 13px;
    border: 1px solid #9F9C9D;
  }
}
</style>
